import React from 'react';

import { FormattedMessage } from 'react-intl';

import { IAccountUserResponse } from 'services/account/account.interface';
import { Avatar, Card, Headline2, Text, Util } from 'views/components';
import styles from 'views/components/CardProfile/cardProfile.module.scss';

interface ICardProfile {
  userData?: IAccountUserResponse | null;
  embedded?: boolean;
}

const CardProfile = (props: ICardProfile): React.ReactElement => {
  const { userData, embedded } = props;
  const expertise = userData?.expertise;

  const content = (
    <>
      <div className={styles.card__header}>
        <Util className={styles.card__wrapper_img}>
          <Avatar size="huge" mode="user" image={userData ? userData.photoUrl : ''} />
        </Util>
        <div className={styles.card__identity}>
          <Headline2 marginBottom="1.6px">
            {userData?.firstName} {userData?.lastName}
          </Headline2>
          <Text variant="body" color="var(--sk-text-subtle)">
            {userData?.email}
          </Text>
        </div>
      </div>
      <div className={styles.card__details}>
        <ul className={styles.card__infoList}>
          <li className={styles.card__infoItem}>
            <Util marginBottom="0.25rem">
              <Text variant="label">
                <FormattedMessage id="user-profile.info_expertise" />
              </Text>
            </Util>
            <Text>{expertise?.name || '-'}</Text>
          </li>
          <li className={styles.card__infoItem}>
            <Util marginBottom="0.25rem">
              <Text variant="label">
                <FormattedMessage id="user-profile.info_position" />
              </Text>
            </Util>
            <Text>{userData?.position?.name || '-'}</Text>
          </li>
          <li className={styles.card__infoItem}>
            <Util marginBottom="0.25rem">
              <Text variant="label">
                <FormattedMessage id="user-profile.info_target-position" />
              </Text>
            </Util>
            <Text>{userData?.targetPosition?.name || '-'}</Text>
          </li>
          <li className={styles.card__infoItem}>
            <Util marginBottom="0.25rem">
              <Text variant="label">
                <FormattedMessage id="user-profile.info_department" />
              </Text>
            </Util>
            <Text>{userData?.department?.name || '-'}</Text>
          </li>
          <li className={styles.card__infoItem}>
            <Util marginBottom="0.25rem">
              <Text variant="label">
                <FormattedMessage id="user-profile.info_unit" />
              </Text>
            </Util>
            <Text>{userData?.unit?.name || '-'}</Text>
          </li>
        </ul>
      </div>
    </>
  );

  if (embedded) {
    return <div className={styles.card}>{content}</div>;
  }

  return <Card className={styles.card}>{content}</Card>;
};
export { CardProfile };
